



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { focus } from '@/directives';
import VueMarkdown from 'vue-markdown';

@Component({
  directives: {
    focus,
    blur,
  },
  components: {
    VueMarkdown,
  },
})
export default class EditorDescription extends Vue {
  @Prop({ default: '' }) private value!: string;
  @Prop() private placeholder!: string;

  private edit: boolean = false;
  private currentValue: string = this.value;

  @Watch('value')
  private updateCurrentValue(val: string) {
    this.currentValue = val;
  }

  private onEdit() {
    this.edit = true;
  }

  private onDone() {
    this.edit = false;
    this.$emit('change', this.currentValue);
  }

  private onCancel() {
    this.edit = false;
    this.currentValue = this.value;
  }
}
